import { Button, Flex, Stack } from "@mantine/core";
import style from "./precision.module.css";

import { IconArrowRight } from "@tabler/icons-react";
import { Link, useNavigate } from "react-router-dom";
import FalsePositivesChart from "./components/false-positives-chart";
import TruePositivesChart from "./components/true-positives-chart";
import ScanExamples from "../../../../organisms/scan-examples/scan-examples";
import { useTranslation } from "react-i18next";
import { freeTrialWithoutPaymentCardEnabled } from "../../../../App";

const PrecisionPage = () => {
    const { t } = useTranslation(["dashboard", "landing-page"]);
    const navigate = useNavigate();

    return (
        <div className={style.wrapper}>
            <div className={style.innerWrapper}>
                <Flex className={style.desktopContent} w={"100%"} justify={"space-between"} columnGap={"5rem"}>
                    <Stack maw={450} spacing={"0.5rem"} mt={"0rem"}>
                        <h1 className={style.header}>{t("precision.title", { ns: "landing-page" })}</h1>

                        <p className={style.text}>{t("precision.intro", { ns: "landing-page" })}</p>
                        <br />
                        <p className={style.text}>{t("precision.factors", { ns: "landing-page" })}</p>
                        <br />
                        <p className={style.text}>{t("precision.paraphrasing", { ns: "landing-page" })}</p>

                        <br />
                        <p className={style.text}>{t("precision.methodology", { ns: "landing-page" })}</p>

                        <Flex w={"12rem"} mt={"1rem"} mb={"4rem"}>
                            <Button
                                onClick={() => navigate("/sign-up")}
                                color="dark"
                                radius={"xl"}
                                variant="filled"
                                rightIcon={<IconArrowRight size={"1rem"} />}
                            >
                                {freeTrialWithoutPaymentCardEnabled ? t("hero.cta.try_free", { ns: "landing-page" }) : t("hero.cta.try_free_30_days", { ns: "landing-page" })}
                            </Button>
                        </Flex>
                    </Stack>

                    <Stack spacing={"6rem"}>
                        <FalsePositivesChart />

                        <TruePositivesChart />
                    </Stack>
                </Flex>

                <Stack className={style.mobileContent} maw={450} spacing={"0.5rem"} mt={"0rem"}>
                    <h1 className={style.header}>{t("precision.title", { ns: "landing-page" })}</h1>

                    <p className={style.text}>{t("precision.intro", { ns: "landing-page" })}</p>
                    <br />
                    <p className={style.text}>{t("precision.factors", { ns: "landing-page" })}</p>
                    <br />

                    <FalsePositivesChart />
                    <br />
                    <p className={style.text}>{t("precision.paraphrasing", { ns: "landing-page" })}</p>

                    <br />
                    <TruePositivesChart />
                    <br />
                    <p className={style.text}>{t("precision.methodology", { ns: "landing-page" })}</p>

                    <Flex w={"12rem"} mt={"1rem"} mb={"4rem"}>
                        <Link to="/sign-up">
                            <Button color="dark" radius={"xl"} variant="filled" rightIcon={<IconArrowRight size={"1rem"} />}>
                                {freeTrialWithoutPaymentCardEnabled ? t("hero.cta.try_free", { ns: "landing-page" }) : t("hero.cta.try_free_30_days", { ns: "landing-page" })}
                            </Button>
                        </Link>
                    </Flex>
                </Stack>

                <Flex wrap={"wrap"} columnGap={"5rem"} rowGap={"1rem"} mt={"2rem"} mb={"8rem"}>
                    <p className={style.text}>{t("precision.false_positives_explanation", { ns: "landing-page" })}</p>
                    <p className={style.text}>{t("precision.assessment_importance", { ns: "landing-page" })}</p>
                </Flex>

                <section className={`${style.tutorialWrapper} `}>
                    <h2 className={style.header}>{t("how.title")}</h2>
                    <p>{t("how.description")}</p>
                    <ul>
                        <li>{t("how.classifications.ai")}</li>
                        <li>{t("how.classifications.unsure")}</li>
                        <li>{t("how.classifications.probably-not")}</li>
                        <li>{t("how.classifications.original")}</li>
                    </ul>
                    <br />

                    <h4>{t("how.examples-title")}</h4>
                    <ScanExamples />
                </section>

                <section id="result_confidence" className={`${style.tutorialWrapper} `}>
                    <h2 className={style.header}>{t("handling-ai.title")}</h2>
                    <p>{t("handling-ai.description")} </p>
                    <ul>
                        <li>
                            <span style={{ fontWeight: "bold" }}>{t("handling-ai.characteristics.format.title")}</span>
                            {` - ${t("handling-ai.characteristics.format.description")}`}
                        </li>
                        <br />
                        <li>
                            <span style={{ fontWeight: "bold" }}>{t("handling-ai.characteristics.scope.title")}</span>
                            {` - ${t("handling-ai.characteristics.scope.description")}`}
                        </li>
                        <br />
                        <li>
                            <span style={{ fontWeight: "bold" }}>{t("handling-ai.characteristics.scope-accross-texts.title")}</span>
                            {` - ${t("handling-ai.characteristics.scope-accross-texts.description")}`}
                        </li>
                    </ul>
                </section>
            </div>
        </div>
    );
};

export default PrecisionPage;
